import styled from 'styled-components/macro';
import SimpleList from 'styled/SimpleList';

const PublicationsList = styled(SimpleList)`
  width: calc(100% - 64px);
  margin: 0 32px;
  border-spacing: 0;
  border-collapse: collapse;
`;

export default PublicationsList;
